import classNames from 'classnames';
import { t } from "../i18n";
import { jsx as _jsx, jsxs as _jsxs } from "preact/compat/jsx-runtime";
/**
 * For information about how and when to use this component,
 * [refer to its full documentation page](https://design.cms.gov/components/badge/).
 */
export const Badge = props => {
  const {
    className = '',
    children,
    hideScreenReaderText = false,
    screenReaderText,
    size,
    variation,
    ...others
  } = props;
  const sizeClasses = {
    big: 'ds-c-badge--big'
  };
  const variationClass = variation && `ds-c-badge--${variation}`;
  const classes = classNames('ds-c-badge', variationClass, sizeClasses[size], className);
  const showScreenReaderText = variation && !hideScreenReaderText;
  const variationText = variation && t(`badge.${variation}`) + ': ';
  return /*#__PURE__*/_jsxs("span", {
    className: classes,
    ...others,
    children: [showScreenReaderText && /*#__PURE__*/_jsx("span", {
      className: "ds-u-visibility--screen-reader",
      children: screenReaderText || variationText
    }), children]
  });
};
export default Badge;